import useTransactionsStore from '@/store/modules/transactions';
import { defineComponent, ref } from 'vue';
import { numberFormat } from '@/utils/helpers';
import router from '@/router';
import { storeToRefs } from 'pinia';
export default defineComponent({
    name: 'TransactionItem',
    props: {
        transaction: {
            type: Object,
            required: true,
        },
    },
    setup(props) {
        const transactionsStore = useTransactionsStore();
        const { selectedTransaction, selectedChannel, buyFlow } = storeToRefs(transactionsStore);
        const transactionObject = ref(props.transaction);
        const status = transactionsStore.getTransactionStatus(transactionObject.value?.status, transactionObject.value?.transactionType);
        const onViewTransactionClicked = async () => {
            selectedTransaction.value =
                transactionObject.value;
            const { transactionType } = selectedTransaction.value;
            switch (transactionType) {
                case 'collection':
                    selectedChannel.value = selectedTransaction.value.source
                        .accountType;
                    break;
                case 'payment':
                    selectedChannel.value = selectedTransaction.value.destination
                        .accountType;
                    break;
                default:
                    break;
            }
            buyFlow.value = false;
            await router.push('/transaction');
        };
        const onKeyPress = () => {
            console.log();
        };
        return {
            transactionObject,
            numberFormat,
            onViewTransactionClicked,
            onKeyPress,
            status,
        };
    },
});
